import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { Badge } from "@ionic-native/badge";

import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

import { NotificacionDetallePage } from "../../pages/notificacion-detalle/notificacion-detalle";

@Component({
  selector: "page-mensajes",
  templateUrl: "mensajes.html"
})
export class MensajesPage {
  data: any = {};
  items: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public global: GlobalProvider,
    public conector: ConectorProvider,
    private badge: Badge
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.conector.getMensajes().subscribe(data => {
      this.items = data["notificaciones"];
      console.log("mensajes", this.items);
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad MensajesPage");

    //limpiamos el badge
    this.badge.clear();
    this.conector.clearBagde().subscribe(data => {
      console.log("clear-badge", data);
    });
  }

  iraNotificacion(item) {
    console.log("ir a notificacion-detalle ", item);
    this.navCtrl.push(NotificacionDetallePage, { notif: item });
  }
}



// WEBPACK FOOTER //
// ./src/pages/mensajes/mensajes.ts